export default "__VITE_PUBLIC_ASSET__0cf8584c__"